<template>
  <div class="expression">
    <el-tabs type="card" v-model="currentFace">
      <el-tab-pane
        class="content"
        v-for="(title, i) of faceList"
        :key="i"
        :label="title"
        :name="i.toString()"
        @click="currentFace = i"
      >
        <span
          v-for="(value, index) of data[i]"
          @click="choose(value)"
          :key="index"
          :class="[ i ? 'normalface' : 'qq' ]"
        >
          <img v-lazy="value.src" alt="表情" />
        </span>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  name: 'expression',
  data () {
    return {
      faceList: ['QQ表情', '常用表情', '新表情'],
      currentFace: 0,
      data: [[], [], []],
    }
  },
  created () {
    this.init()
  },
  methods: {
    // 初始化表情
    init () {
      const toData = i => {
        return {
          id: i,
          ubb: "[@F_" + i + "G@]",
          src: "https://staticres.yifucj.com/common/emotion/gif/F_" + i + ".gif"
        }
      }
      for(var i = 75; i < 193; i++ ){
        this.data[0].push(toData(i))
      }

      for(var i = 1; i < 75; i++ ){
        this.data[1].push(toData(i))
      }

      for(var i = 1001; i < 1072; i++ ){
        this.data[2].push(toData(i))
      }
    },
    choose (value) {
      this.$emit('select', value)
    }
  }
}

</script>

<style lang="less" scoped>
.expression .content {
  height: 150px; overflow-y: auto;
  span {
    border: 1px solid #F1F1F1; padding: 4px; float: left;
    &.qq {
      img {
        width: 24px; height: 24px;
      }
      &:not(:nth-child(10n + 1)) {
        border-left: none;
      }
      &:nth-child(n + 11) {
        border-top: none;
      }
    }
    &.normalface {
      img {
        width: 44px; height: 44px;
      }
      &:not(:nth-child(6n + 1)) {
        border-left: none;
      }
      &:nth-child(n + 7) {
        border-top: none;
      }
    }
  }
}
</style>
